<template>
    <div class="sidebar-main p-0" style="width:7%;position:relative;">
        <div v-if="!enableEditMode" style="height:95%;overflow:auto">
            <nav class="sidebar-wrapper" id="home_page_sidemenu" style="height:100%;overflow:auto;overflow-x: hidden;">
                <ul class="sidebar-menu move-center-vertically mb-0" ref="sideMenuWrapper" style="list-style-type:none;padding:4px;position:relaive">
                    <template v-for="panel in fixedAndDynamicPanelsCombinedTogether">
                        <li v-if="getPanelDetails(panel)" ref="sideMenuRefs" :id="panel" @click="navigateToSelectedMenu(getPanelDetails(panel))" :class="{'activeEntry':selectedPanel==getPanelDetails(panel)._id}"  :key="getPanelDetails(panel)._id" class="sidebar remove-border w-100">
                            <i v-if="getPanelDetails(panel).icon_svg_callback && !getPanelDetails(panel).fixed_icon" :class="getPanelDetails(panel).icon_svg_callback"></i>
                            <div v-if="getPanelDetails(panel).icon_svg_callback && getPanelDetails(panel).fixed_icon" v-html="getPanelDetails(panel).icon_svg_callback"></div>
                            <div v-else-if="getPanelDetails(panel).cover_photo" style="height: 35px;width: 35px;">
                                <img :src="getProxyConvertedURL(getPanelDetails(panel).cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                            </div>
                            <div v-else-if="getPanelDetails(panel).type == 'bookmark'" class="text-center" style="position:relative" v-html="bookmarkIcon"></div>
                            <div v-else-if="getPanelDetails(panel).type == 'Saved Search'" class="text-center" style="position:relative" v-html="savedSearchIcon"></div>
                            <div :style="['bookmark','Saved Search'].includes(getPanelDetails(panel).type)?'white-space: nowrap;width: 64px;overflow: hidden;text-overflow: ellipsis;':''" :title="getPanelDetails(panel).label">{{$t(getPanelDetails(panel).label)}}</div>
                            <div v-if="Object.keys(getPanelDetails(panel)).includes('has_new_label') && getPanelDetails(panel).has_new_label && showNewMessageTag" class='new-tag-styles'>{{$t('New')}}</div>
                        </li>
                    </template>
                </ul>
            </nav>
        </div>
        <div v-if="enableEditMode" style="height:100%;border: 1px solid #21698f;background: #0c2734 !important;border-radius:8px">
            <div style="height:calc(100% - 50px);overflow:auto">
                <div v-if="getLoggedInUserType() == 'SystemAdmin'" class="config-panels mt-2 mb-2">
                    <div class="global-panel-tag">Global</div>
                    <button v-if="getLoggedInUserType() == 'SystemAdmin'" @click="openAddRemovePanelsDialog('fixed')" type="button" class="btn btn-primary" style="color:#fff">{{$t('Add')}}</button>
                        <template>
                            <draggable
                                v-if="configuredQuickAccessPanelCoreEntries[0]"
                                :list="configuredQuickAccessPanelCoreEntries[0].panel_ids"
                                :disabled="false"
                                class="list-group"
                                ghost-class="ghost"
                                drag-class="dragging-field"
                                :move="checkMove"
                                :scroll-sensitivity="200"
                                :force-fallback="true"
                                @start="dragging = true"
                                @end="dragging = false"
                                @change="updatePanelsReOrdering($event,'fixed',configuredQuickAccessPanelCoreEntries[0].panel_ids)"
                            >
                                <template v-for="gPanel in configuredQuickAccessPanelCoreEntries[0].panel_ids" >
                                    <div v-if="getPanelDetails(gPanel) && !['bookmark','Saved Search'].includes(getPanelDetails(gPanel).type)" :key="gPanel" class="sidebar sidebar-config" :class="{'disableConfig':getLoggedInUserType() != 'SystemAdmin'}">
                                        <i v-if="getPanelDetails(gPanel).icon_svg_callback && !getPanelDetails(gPanel).fixed_icon" :class="getPanelDetails(gPanel).icon_svg_callback"></i>
                                        <div v-if="getPanelDetails(gPanel).icon_svg_callback && getPanelDetails(gPanel).fixed_icon" v-html="getPanelDetails(gPanel).icon_svg_callback"></div>
                                        <div v-else-if="getPanelDetails(gPanel).cover_photo" style="height: 35px;width: 35px;">
                                            <img :src="getProxyConvertedURL(getPanelDetails(gPanel).cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                                        </div>
                                        <div v-else-if="getPanelDetails(gPanel).type == 'bookmark'" class="text-center" style="position:relative" v-html="bookmarkIcon"></div>
                                        <div v-else-if="getPanelDetails(gPanel).type == 'Saved Search'" class="text-center" style="position:relative" v-html="savedSearchIcon"></div>
                                    <div :style="['bookmark','Saved Search'].includes(getPanelDetails(gPanel).type)?'white-space: nowrap;width: 64px;overflow: hidden;text-overflow: ellipsis;':''">{{ $t(getPanelDetails(gPanel).label) }}</div>
                                        <cancel-icon v-if="getLoggedInUserType() == 'SystemAdmin'" class="remove-panel-icon" @click.native="removePanelFromConfiguredFixedRegion(gPanel)"></cancel-icon>
                                    </div>
                                </template>
                            </draggable>
                        </template>
                </div>
                <div v-if="getLoggedInUserType() == 'SystemAdmin'" style="width: 83%;border: 1px solid #4c4c4c;margin: 0px 10px;"></div>
                <div class="config-panels  mt-2 mb-2">
                    <div class="user-panel-tag">Mine</div>
                    <button @click="openAddRemovePanelsDialog('dynamic')" type="button" class="btn btn-primary mt-1" style="color:#fff">{{$t('Add')}}</button>
                    <draggable
                        v-if="configuredQuickAccessPanelPluginEntries[0]"
                        :list="configuredQuickAccessPanelPluginEntries[0].panel_ids"
                        :disabled="false"
                        class="list-group"
                        ghost-class="ghost"
                        drag-class="dragging-field"
                        :move="checkMove"
                        :scroll-sensitivity="200"
                        :force-fallback="true"
                        @start="draggingDynamicPanels = true"
                        @end="draggingDynamicPanels = false"
                        @change="updatePanelsReOrdering($event,'dynamic',configuredQuickAccessPanelPluginEntries[0].panel_ids)"
                    >
                        <template v-for="mPanel in configuredQuickAccessPanelPluginEntries[0].panel_ids" >
                            <div v-if="getPanelDetails(mPanel)" :key="mPanel" class="sidebar sidebar-config">
                                <i v-if="getPanelDetails(mPanel).icon_svg_callback && !getPanelDetails(mPanel).fixed_icon" :class="getPanelDetails(mPanel).icon_svg_callback"></i>
                                <div v-if="getPanelDetails(mPanel).icon_svg_callback && getPanelDetails(mPanel).fixed_icon" v-html="getPanelDetails(mPanel).icon_svg_callback"></div>
                                <div v-else-if="getPanelDetails(mPanel).cover_photo" style="height: 35px;width: 35px;">
                                    <img :src="getProxyConvertedURL(getPanelDetails(mPanel).cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                                </div>
                                <div v-else-if="getPanelDetails(mPanel).type == 'bookmark'" class="text-center" style="position:relative" v-html="bookmarkIcon"></div>
                                <div v-else-if="getPanelDetails(mPanel).type == 'Saved Search'" class="text-center" style="position:relative" v-html="savedSearchIcon"></div>
                                <div :style="['bookmark','Saved Search'].includes(getPanelDetails(mPanel).type)?'white-space: nowrap;width: 64px;overflow: hidden;text-overflow: ellipsis;':''">{{ $t(getPanelDetails(mPanel).label) }}</div>
                                <cancel-icon class="remove-panel-icon" @click.native="removePanelFromConfiguredDynamicRegion(mPanel)"></cancel-icon>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
            <div @click="enableEditMode = false,loadPanelsBasedOnConfiguration()" class="reset-button blinking-button exit-button-styles" style="height:40px">Exit</div>
        </div>
        <div v-if="openPanelsDialog" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{workspaceType == 'fixed'?$t('Select Global Panel(s)'):$t('Select Panel(s)')}}</h6>
                        <button @click="openPanelsDialog = false,filterPanelsBy = ''" type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
                    width: 30px !important;
                    color: #fff;"></cancel-icon></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="search-bar-comm-style">
                                <input type="text" v-model="filterPanelsBy" class="bg-transparent rounded text-light" ref="focus"
                                    placeholder="Search panel">
                                <cancel-icon v-if="filterPanelsBy.length > 0" @click="filterPanelsBy = ''" style="inset-inline-end :3px;top: 5px;width:30px;height:30px;"></cancel-icon>
                                <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                                </svg>
                        </div>
                        <div class="col-md-12 pl-0 pt-0 ml-2" style="overflow: auto;height: calc(100% - 50px);">
                            <template  v-for="(panels, type, index) in groupedPanels">
                                <hr v-if="index !== 0" :key="index" style="border-top: 1px solid #2a2a2a;margin-top: 10px;margin-bottom: 0px;">
                                <div :key="index" :class="{'pl-3 ml-2 sub-panel': !['Core','Plugins','Bookmarks','Saved Search'].includes(type)}">
                                    <div :class="{'mt-3':index > 0}" class="ml-1 panel-headers">
                                        <svg v-if="!openedPanel.includes(type)" v-on:click.stop.prevent="addToPanel(type)"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#aaa" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                        </svg>
                                        <svg v-else v-on:click.stop.prevent="removePanel(type)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#aaa" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                        </svg>
                                        {{ type }}</div>
                                        <ul v-if="!openedPanel.includes(type)" class="tags-display-ul p-0 active-tag m-0" :key="index">
                                            <li v-if="panels.length === 0" class="no-data-found">{{$t('No data found')}}</li>
                                            <li v-for="panel in panels" :key="panel._id" v-on:click="selectPanel(panel)"
                                            :class="{activePanel: panelIDList.includes(panel._id), disabledPanel: panelIDsCannotBeSelected.includes(panel._id)}" class='view-tags'>
                                                <i v-if="panel.icon_svg_callback && !panel.fixed_icon" :class="panel.icon_svg_callback"></i>
                                                <div v-if="panel.icon_svg_callback && panel.fixed_icon" v-html="panel.icon_svg_callback"></div>
                                                <div v-else-if="panel.cover_photo" style="height: 35px;width: 35px;">
                                                    <img :src="getProxyConvertedURL(panel.cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                                                </div>
                                                <div v-else-if="type == 'Bookmarks'" class="text-center" style="position:relative;top:1px" v-html="bookmarkIcon"></div>
                                                <div v-else-if="type == 'Saved Search'" class="text-center" style="position:relative" v-html="savedSearchIcon"></div>
                                                <span :title="panel.label" style="white-space: nowrap;min-width: 60px;max-width:100px;overflow: hidden;text-overflow: ellipsis;">{{$t(panel.label)}}</span>
                                            </li>
                                        </ul>
                                    </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer p-1 primary-btn-style">
                        <div>
                            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click="openPanelsDialog = false,filterPanelsBy = ''">{{$t('Cancel')}}</button>
                            <button class="btn btn-outline-primary ml-1 mr-2" @click="openPanelsDialog = false,saveSelectedPanels(),filterPanelsBy = ''">{{$t('Save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!enableEditMode" class="dropdown" style="width: 100%;background: #15171b;inset-inline-end :5px;position:relative;top:3px">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#8f8f8f" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="bi bi-three-dots dropdown-toggle" viewBox="0 0 16 16">
                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/>
            </svg>
            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="dropdownMenuButton">
                <a @click="enableEditMode = true"  class="dropdown-item p-2">
                    <span>{{$t('Edit')}}</span>
                </a>
            </div>
        </div>
        <reload-panel v-if="openReloadPanel" :message="reloadPanelMessage" @closeReloadPanel="closeReloadPanel" @reloadButtonClicked="reloadButtonClicked"></reload-panel>
    </div> 
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import cancelIcon from "./InlineCancelField.vue";
import "bootstrap-icons/font/bootstrap-icons.css";
import reloadPanel from "./AdvancedSearchReloadPanel.vue";
import Utils from '../../components.utils';
import draggablePlugin from "vuedraggable";

export default {
    props:['isActive','newMessageNotificationTagVisible','selectFirstMenu'],
    data(){
        return{
            enableEditMode:false,
            openPanelsDialog:false,
            allQuickAccessPanels:[],
            allQuickAccessPluginPanels:[],
            panelIDList:[],
            workspaceType:null,
            configuredQuickAccessPanelCoreEntries:[],
            configuredQuickAccessPanelPluginEntries:[],
            fixedAndDynamicPanelsCombinedTogether:[],
            openReloadPanel:false,
            panelIDsCannotBeSelected:[],
            bookmarkIcon:Utils.getBookmarkSvg(),
            savedSearchIcon:Utils.getSavedSearchSvg(),
            dragging: false,
            draggingDynamicPanels:false,
            selectedPanel:null,
            isGlobalOpen:false,
            isUserOpen:false,
            openedPanel:[],
            filterPanelsBy:'',
            reloadPanelMessage:'Quick access panel configuration has been updated by admin user, Please click the reload button to update.',
            sideMenusArr:[],
            showNewMessageTag:false
        }
    },
    watch:{
        isActive(newVal,oldVal){
            if(newVal != oldVal){
                for (let i = 0; i < this.fixedAndDynamicPanelsCombinedTogether.length; i++) {
                    let panelDetails = this.getPanelDetails(this.fixedAndDynamicPanelsCombinedTogether[i]);
                    if (panelDetails && (panelDetails._id == newVal || panelDetails.pluginName && panelDetails.pluginName.includes(newVal) || panelDetails.label.includes(newVal))) {
                        this.selectedPanel = panelDetails._id;
                    }
                }
            }
        },
        selectFirstMenu(newVal){
            if(newVal){
                if (this.$refs.sideMenuRefs && this.$refs.sideMenuRefs.length > 0) {
                    const firstPanelElement = this.$refs.sideMenuRefs[0]; // Access the first `li`
                    const firstPanelId = firstPanelElement.id; // Get the ID of the first `li`
                    if (firstPanelId) {
                        this.navigateToSelectedMenu(this.getPanelDetails(firstPanelId)) 
                    }
                }else{
                    this.$router.push({name:'explorer'});
                }
            }
        },
        newMessageNotificationTagVisible(newVal,oldVal){
            if(newVal != oldVal){
                this.showNewMessageTag = newVal;
            }
        },
        fixedAndDynamicPanelsCombinedTogether: {
            handler() {
                this.$nextTick(() => {
                    if(this.selectFirstMenu){
                        if (this.$refs.sideMenuRefs && this.$refs.sideMenuRefs.length > 0) {
                            const firstPanelElement = this.$refs.sideMenuRefs[0]; // Access the first `li`
                            const firstPanelId = firstPanelElement.id; // Get the ID of the first `li`
                            if (firstPanelId) {
                                this.navigateToSelectedMenu(this.getPanelDetails(firstPanelId)) 
                            }
                        }else{
                            this.$router.push({name:'explorer'});
                        }
                    }
                });
            },
            immediate: true, // Ensures the watcher runs immediately
        },
    },
    components:{
        'cancel-icon':cancelIcon,
        "reload-panel":reloadPanel,
        "draggable": draggablePlugin
    },
    computed: {
        draggingInfo() {
            return this.dragging ? "under drag" : "";
        },
        groupedPanels() {
            return this.allQuickAccessPanels.reduce((acc, panel) => {
                let category = ''; // Optional category for anything else

                if(['stage','pipeline'].includes(panel.type)){
                    category = 'Media Pipeline';
                }else if(panel.type == 'Saved Search'){
                    category = 'Saved Search';
                }else if(panel.type == 'media_qc'){
                    category = 'Media Qc'
                }else if(panel.scope == 'external_plugin'){
                    category = 'Plugins'
                    if (panel.display_in_sublevel) {
                        const pluginCategory = this.formatCategoryName(panel.pluginName);
                        if (!acc[pluginCategory]) {
                            acc[pluginCategory] = [];
                        }
                        acc[pluginCategory].push(panel);
                        return; // Skip adding it to 'Plugins' directly
                    }
                }else if(panel.type == 'bookmark'){
                    category = 'Bookmarks'
                }else{
                    category = 'Core'
                }
                if (!acc[category]) {
                    acc[category] = [];
                }
                if (!this.filterPanelsBy || panel.label.toLowerCase().includes(this.filterPanelsBy.toLowerCase())) {
                    acc[category].push(panel);
                    this.openedPanel = [];
                }
                if(this.workspaceType == 'fixed'){
                    delete acc['Bookmarks'];
                    delete acc['Saved Search'];
                }
                return acc;
            }, {});
        },
        pluginIDInfoMapper() {
            const map = this.allQuickAccessPanels.reduce((acc, item) => {
            acc[item._id] = { ...item }; // Clone primary details
            return acc;
            }, {});

            // // Merge additional details
            // this.allQuickAccessPluginPanels.forEach(item => {
            // if (map[item._id]) {
            //     Object.assign(map[item._id], item); // Merge extra details
            // } else {
            //     map[item._id] = { ...item }; // If no primary details, still add
            // }
            // });

            return map;
        },
    },
    methods: {
        getProxyConvertedURL(url){
            return Utils.convertToLoginIPDomainName(url);
        },
        checkIfGivenPluginExistsInSideMenu(pluginID) {
            const mItem = this.allQuickAccessPanels.findIndex(panel => panel.id === pluginID);
            if (mItem > -1) {
                const panelId = this.allQuickAccessPanels[mItem]._id;
                let fItem = this.fixedAndDynamicPanelsCombinedTogether.findIndex(e => e == panelId);
                if(fItem > -1){
                    return true;
                }
            }
            return false;
        },
        //------------------Navigation in view mode ---------------------
        navigateToSelectedMenu(panelInfo){
            if(['Saved Search','bookmark'].includes(panelInfo.type)){
                let pIndex = this.allQuickAccessPanels.findIndex(e => e.id == 'catalogs')
                if(pIndex > -1){
                    this.selectedPanel = this.allQuickAccessPanels[pIndex]._id;
                }
            }else{
                this.selectedPanel = panelInfo._id;
            }
            this.$emit("navigateToSelectedPanel",panelInfo,'onClick',[],panelInfo)
        },
        //---------------------------------------------------------------
        exitButtonClick(){
            this.$nextTick(() => {
                const observer = new MutationObserver((mutations, obs) => {
                    if (this.$refs.sideMenuRefs.length) {
                        this.handleSidebarUpdate();
                        obs.disconnect(); // Stop observing after first successful check
                    }
                });

                const sidebarWrapper = this.$refs.sideMenuWrapper;
                if (sidebarWrapper) {
                    observer.observe(sidebarWrapper, { childList: true, subtree: true });
                }
            });
        },
        handleSidebarUpdate() {
            if (!this.$refs.sideMenuRefs || this.$refs.sideMenuRefs.length === 0) {
                this.$emit("unsetComponent");
            } else {
                if (!this.selectedPanel) {
                    this.selectFirstMenu = true;
                } else {
                    let isAlreadyExists = false;
                    this.$refs.sideMenuRefs.forEach(element => {
                        if (element.getAttribute('id') === this.selectedPanel) {
                            isAlreadyExists = true;
                        }
                    });

                    if (!isAlreadyExists) {
                        this.selectFirstMenu = true;
                    }
                }
            }
        },
        formatCategoryName(name) {
            if (!name) return "";
            return name
                .replace(/[-_]+/g, ' ') // Replace hyphens/underscores with space
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
        },
        closeReloadPanel(){
            this.openReloadPanel = false;
        },
        addToPanel(type){
            if(this.openedPanel.includes(type)){
                return;
            }
            this.openedPanel.push(type);
        },
        removePanel(type){
            this.$set(this, 'openedPanel', this.openedPanel.filter(e => e !== type));
        },
        reloadButtonClicked(){
            this.getAllQuickAccessPanelEntries();
            this.openReloadPanel = false;
            this.loadPanelsBasedOnConfiguration();
        },
        loadPanelsBasedOnConfiguration(){
            setTimeout(() => {
                if (this.$refs.sideMenuRefs.length > 0) {
                    this.handleSidebarUpdate();
                }
            }, 0);
        },
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        openAddRemovePanelsDialog(type){
            this.openPanelsDialog = true;
            this.workspaceType = type;
            if(type == 'fixed'){
                if(this.configuredQuickAccessPanelCoreEntries[0])this.panelIDList = [...this.configuredQuickAccessPanelCoreEntries[0].panel_ids];
                if(this.configuredQuickAccessPanelPluginEntries[0])this.panelIDsCannotBeSelected = [...this.configuredQuickAccessPanelPluginEntries[0].panel_ids];
            }else{
                if(this.configuredQuickAccessPanelPluginEntries[0])this.panelIDList = [...this.configuredQuickAccessPanelPluginEntries[0].panel_ids];
                if(this.configuredQuickAccessPanelCoreEntries[0])this.panelIDsCannotBeSelected = [...this.configuredQuickAccessPanelCoreEntries[0].panel_ids];
            }
        },
        removePanelFromConfiguredFixedRegion(panelID){
            if(confirm('Are you sure you want to remove selected panel from global panels?')){
                let payload = {'userId':this.getLoggedInUserId(),'params':{}};
                payload.params['panel_order'] = 'fixed';
                payload.params["panel_ids"] = this.configuredQuickAccessPanelCoreEntries[0].panel_ids.filter(e => e != panelID);
                payload.params["type"] = 'QuickAccessPanel',
                this.submitConfiguredQuickAccesPanels(payload).then((data) => {
                    if (data.statusCode == 200) {
                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                })
            }
        },
        removePanelFromConfiguredDynamicRegion(panelID){
            if(confirm('Are you sure you want to remove selected panel from your panel?')){
                let payload = {'userId':this.getLoggedInUserId(),'params':{}};
                payload.params['panel_order'] = 'dynamic';
                payload.params["panel_ids"] = this.configuredQuickAccessPanelPluginEntries[0].panel_ids.filter(e => e != panelID);
                payload.params["type"] = 'QuickAccessPanel',
                this.submitConfiguredQuickAccesPanels(payload).then((data) => {
                    if (data.statusCode == 200) {
                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                })
            }
        },
        updatePanelsReOrdering(event,type, IDList){
            console.log("Dragged element event",event)
            this.workspaceType = type;
            this.panelIDList = IDList;
            this.saveSelectedPanels();
        },
        saveSelectedPanels(){
            let payload = {'userId':this.getLoggedInUserId(),'params':{}};
            payload.params['panel_order'] = this.workspaceType;
            payload.params["panel_ids"] = this.panelIDList;
            payload.params["type"] = 'QuickAccessPanel';
            this.submitConfiguredQuickAccesPanels(payload).then((data) => {
                if (data.statusCode == 200) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            })
        },
        selectPanel(panelInfo){
            if(!this.panelIDList.includes(panelInfo._id)){
                this.panelIDList.push(panelInfo._id)
            }else{
                this.panelIDList.splice(this.panelIDList.indexOf(panelInfo._id),1);
            }
        },
        getAllQuickAccessPanelEntries(){
            this.getAllQuickAccessPanels().then((data) => {
                this.allQuickAccessPanels = data.user_work_space;
                this.allQuickAccessPluginPanels = data.plugins_info;
                this.getConfiguredQuickAccessPanel().then((data) => { //Configured
                    this.configuredQuickAccessPanelCoreEntries = data.user_workspaces_order.filter(panel => panel.panel_order === "fixed");
                    this.configuredQuickAccessPanelPluginEntries = data.user_workspaces_order.filter(panel => panel.panel_order === "dynamic" && panel.user_id == this.getLoggedInUserId());
                    if(this.configuredQuickAccessPanelPluginEntries && this.configuredQuickAccessPanelPluginEntries.length > 0 && this.configuredQuickAccessPanelCoreEntries && this.configuredQuickAccessPanelCoreEntries.length > 0){
                        this.fixedAndDynamicPanelsCombinedTogether = this.configuredQuickAccessPanelCoreEntries[0].panel_ids.concat(this.configuredQuickAccessPanelPluginEntries[0].panel_ids);
                    }else if(this.configuredQuickAccessPanelCoreEntries.length > 0){
                        this.fixedAndDynamicPanelsCombinedTogether = this.configuredQuickAccessPanelCoreEntries[0].panel_ids
                    }else if(this.configuredQuickAccessPanelPluginEntries.length > 0){
                        this.fixedAndDynamicPanelsCombinedTogether = this.configuredQuickAccessPanelPluginEntries[0].panel_ids
                    }
                    if(this.isActive){
                        for (let i = 0; i < this.fixedAndDynamicPanelsCombinedTogether.length; i++) {
                            let panelDetails = this.getPanelDetails(this.fixedAndDynamicPanelsCombinedTogether[i]);
                            if (panelDetails && (panelDetails._id == this.isActive || panelDetails.pluginName.includes(this.isActive) || panelDetails.label.includes(this.isActive))) {
                                this.selectedPanel = panelDetails._id;
                            }
                        }
                    }
                })
            })
        },
        handlePanelUpdatedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let panel_info = notification.message;
                if(panel_info.panel_order == 'dynamic' && panel_info.user_id == this.getLoggedInUserId()){
                    if(this.configuredQuickAccessPanelPluginEntries[0]){
                        this.$set(this.configuredQuickAccessPanelPluginEntries[0],'panel_ids', panel_info.panel_ids);
                    }else{
                        this.configuredQuickAccessPanelPluginEntries = [];
                        this.configuredQuickAccessPanelPluginEntries[0] = panel_info;
                    }
                    if(this.configuredQuickAccessPanelCoreEntries.length > 0){
                        this.fixedAndDynamicPanelsCombinedTogether = this.configuredQuickAccessPanelCoreEntries[0].panel_ids.concat(panel_info.panel_ids);
                    }else{
                        this.fixedAndDynamicPanelsCombinedTogether = panel_info.panel_ids;
                    }
                }else if(panel_info.panel_order == 'fixed'){
                    this.openReloadPanel = true;
                }
            }
        },
        handleFavouriteCreatedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let fav_info = notification.message;
                if(notification.message_type == 'FAVORITE_CREATED' &&  fav_info.user_id == this.getLoggedInUserId()){
                    fav_info['label'] = fav_info.name;
                    this.allQuickAccessPanels.push(fav_info)
                }
                if(notification.message_type == 'FAVORITE_DELETED'){
                    this.allQuickAccessPanels = this.allQuickAccessPanels.filter(e => fav_info._id != e._id)
                }
                if(notification.message_type == 'FAVORITE_UPDATED'){
                    let fIndex = this.allQuickAccessPanels.findIndex(e  => e._id == fav_info._id);
                    if(fIndex > -1){
                        fav_info['label'] = fav_info.name;
                        this.$set(this.allQuickAccessPanels, fIndex, fav_info);
                    }
                }
            }
        },
        handlePluginRelatedNotifications(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let panel_info = notification.message;
                if(notification.message_type == 'PLUGIN_UNINSTALLED'){
                    let fIndex = this.fixedAndDynamicPanelsCombinedTogether.findIndex(e => this.getPanelDetails(e).id == panel_info._id);
                    if(fIndex > -1){
                        this.reloadPanelMessage = "Plugin present in quick access panel has been uninstalled, Please click the reload button to update."
                        this.openReloadPanel = true;
                        if(this.selectedPanel == this.fixedAndDynamicPanelsCombinedTogether[fIndex])this.setFirstPanelClickVal(fIndex);
                    }
                }
            }
        },
        getPanelDetails(id) {
            return this.pluginIDInfoMapper[id] || null;
        },

        registerforWebsocketNotifications(){
            this.addWSEventListener({
                    eventname:['USER_WORKSPACE_ORDER_UPDATED'],
                    callback:this.handlePanelUpdatedNotification,
                    parent:"quickAccessPanel"}),
            this.addWSEventListener({
                    eventname:['FAVORITE_CREATED','FAVORITE_UPDATED','FAVORITE_DELETED'],
                    callback:this.handleFavouriteCreatedNotification,
                    parent:"quickAccessPanel"}),
            this.addWSEventListener({
                    eventname:['PLUGIN_UNINSTALLED'],
                    callback:this.handlePluginRelatedNotifications,
                    parent:"quickAccessPanel"})
        },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                    eventname:['USER_WORKSPACE_ORDER_UPDATED'],
                    callback:this.handlePanelUpdatedNotification,
                    parent:"quickAccessPanel"}),
            this.removeWSEventListener({
                    eventname:['FAVORITE_CREATED','FAVORITE_DELETED','FAVORITE_UPDATED'],
                    callback:this.handleFavouriteCreatedNotification,
                    parent:"quickAccessPanel"}),
            this.removeWSEventListener({
                    eventname:['PLUGIN_UNINSTALLED'],
                    callback:this.handlePluginRelatedNotifications,
                    parent:"quickAccessPanel"})
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("users",["getLoggedInUserType",'getLoggedInUserId','getLoggedInUserPrivilege']),
        ...mapActions('miscellaneous',['getAllQuickAccessPanels','submitConfiguredQuickAccesPanels','getConfiguredQuickAccessPanel']),
        ...mapGetters('miscellaneous',['getFirstPanelClickVal']),
        ...mapMutations('miscellaneous',['setFirstPanelClickVal'])
    },
    async created() {
        await this.getAllQuickAccessPanelEntries(); //ALL
        this.registerforWebsocketNotifications();
        if(this.newMessageNotificationTagVisible){
            this.showNewMessageTag = true;
        }
    },
    mounted() {
        this.$nextTick(() => {
            if(this.$refs.sideMenuRefs){
                this.sideMenusArr = this.$refs.sideMenuRefs
            }
            if(this.selectFirstMenu){
                if (this.$refs.sideMenuRefs && this.$refs.sideMenuRefs.length > 0) {
                    const firstPanelElement = this.$refs.sideMenuRefs[0]; // Access the first `li`
                    const firstPanelId = firstPanelElement.id; // Get the ID of the first `li`
                    if (firstPanelId) {
                        this.navigateToSelectedMenu(this.getPanelDetails(firstPanelId)) 
                    }
                }else{
                    this.$router.push({name:'explorer'});
                }
            }
        })
    },

}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;


.dropdown-menu{
    background-color:$secondary-background-color !important;
    border: $border-color;
    .dropdown-item{
      color:$text-color;
      font-size:14px !important; 
      word-break: break-word;
    }
}

.collapse-enter-active, .collapse-leave-active {
    transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
    max-height: 200px;
    opacity: 1;
  }
  
  .collapse-enter, .collapse-leave-to {
    max-height: 0;
    opacity: 0;
  }

.sidebar-config{
    color:#eee !important;
}

.search-bar-comm-style {
    height: 30px;
    position: relative;
    padding-inline-start: 0px;
    width: 300px; /* Increased from 200px to 300px */
    margin-top: 5px;
    margin-bottom: 25px;
    margin-inline-start: 13px;

    input {
        border: $border-color;
        height: 39px;
        padding-inline-start: 3%;
        width: 100%; /* Ensure the input takes full width */
    }
  
    svg {
        position: absolute;
        inset-inline-end: 13px;
        top: 12px;
    }
}

.dropdown:hover{
    background: $tags-background-color;
    color: $text-color;
    border-radius: 6px;
    svg{
        fill: $text-color
    }
}
  
.modal-dialog {
    width: 50% !important;
    height: 80%;
    margin: 0;
    padding: 0;
    max-width: 50% !important;
  }
  
 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height:300px;
      padding:10px;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100vh;
  vertical-align: middle;
  margin-inline-end: -4px;
  position: fixed;
  width: 100vw;
  inset-inline-start: 0;
  top: 0px;
  background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}
.modal-header .close {
    margin:0px !important;
    padding: 0xp !important;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}


/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

ul{
    list-style-type: none;
}

.primary-btn-style {
  margin-top:1%;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

  @mixin common-filter-header-styles{
    padding: 5px 10px !important;
    border-radius: 8px;
    top: -3px;
    font-size: 16px;
    position: relative;
}

.config-add-filter{
    background:transparent !important;
    border: 2px solid #21698f !important;
    border-radius: 5px;
    color: #21698f !important;
    padding:5px;
    svg{
        fill: #21698f !important;
    }
    .multiselect__tags{
        background:transparent !important;
    }
}

.config-add-filter:hover{
    color:#eee !important;
    border: 2px solid #2d8fc3 !important;
    svg{
        fill:#2d8fc3 !important;
    }
    .multiselect__tags{
        background:transparent !important;
    }
}

  .sidebar-main{
    background: $secondary-background-color;
  }

  .global-panel-tag{
    color: $add-button-border-color;
    @include common-filter-header-styles;
}

.user-panel-tag{
    color: $add-button-border-color;
    @include common-filter-header-styles;
}

.config-panels{
    color: #d7d7d7;
    border-radius: 5px;
    padding:5px;
    svg{
        fill: $secondary-text-color;
    }
}

.view-tags{
    font-size: 12px;
    display: inline-flex;
    margin:2px !important;
    border-radius: 15px !important;
    min-width: 65px;
    padding: 3px !important;
    text-align: center;
    border: 1px solid #4f4b4b !important;
    width:auto !important;
    background: $tags-background-color;
    position: relative;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
}

.view-tags:hover{
    border: 1px solid #636363 !important;
}

.activePanel{
    color: $active-blue !important;
    border: 1px solid $active-blue !important;
}

.activePanel:hover{
    border: 1px solid $active-blue !important;
}

.sidebar{
    color: $secondary-text-color;
    min-height:70px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    padding:10px;
    position: relative;
    border: 1px solid #0d2435;
    margin:4px 0px;
    i{
        font-size: 20px;
    }
}
.sidebar:hover{
    color: $text-color;
    border: 1px solid #21698f;
}

.remove-panel-icon{
    visibility: hidden;
}

.sidebar:hover .remove-panel-icon{
    visibility: visible;
}

.remove-panel-icon{
    position: absolute;
    inset-inline-end: -8px;
    top: -7px;
    height: 27px;
    width: 27px;
    border: $border-color;
    background: $secondary-background-color;
    border-radius: 30px;
    color: $text-color;
}

.ghost {
    opacity: 0.5;
    height: auto;
    border-radius: 10px;
  }


.disableConfig{
    opacity: 0.5;
    border: none !important;
}
.disableConfig:hover{
    border: none !important;
    color: unset !important;
}
.disabledPanel{
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

.remove-border{
    border: none !important;
}
.dragging-field{
    border: 2px dotted $dull-text-color !important;
  }
.exit-button-styles{
    font-size: 16px;
    height: 36px !important;
    display: flex;
    align-items: center;
    border: 1px solid #a54712 !important;
    background: #a54712 !important;
    animation: pulseButton 1.5s infinite;
    top:4px;
    margin: 3px 20% !important;
    justify-content: center;
}

.activeEntry{
    color:$active-blue !important;
    background: $primary-background !important;
    svg{
      color:$active-blue !important;
      fill:$active-blue !important;
    } 
}

.icon-background-on-hover:hover{
    background: #d1d2d31a;
}
  
.icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
}

@keyframes pulseButton {
    0% {
      box-shadow: 0 0 0 0 rgba(204, 92, 0, 0.7);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(0, 82, 204, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 82, 204, 0);
    }
  }

  .tags-display-ul{
    position: relative;
    user-select: none;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .view-tags{
        display:flex;
        flex-direction: column;
        margin-bottom: 10px !important;
        align-items: center;
        justify-content: center;
        i{
            font-size: 20px;
        }
    }
  }

  .sub-panel{
    .panel-headers{
        font-size: 16px !important;
    }
  }
  .panel-headers{
    color: #d2d2d2;
    font-size: 18px;
    margin-bottom: 8px;
  }
  .new-tag-styles{
    border:$border-color;
    border-radius: 10px;
    background: #2f839e;
    position:absolute;
    top:0px;
    inset-inline-end:0px;
    padding:4px;
    font-size:10px;
    color:$text-color;
    font-weight: 700;
  }
</style>
  